import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-md sticky top-0 z-50 w-full">
      <div className="max-w-full px-4 sm:px-6 w-full mx-auto">
        <div className="flex justify-between items-center h-20 lg:h-28 relative">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 flex items-center z-50">
            <img 
              src={logo} 
              alt="ClinAddis Logo" 
              className="h-14 sm:h-16 lg:h-24 w-auto object-contain"
            />
          </Link>

          {/* Hamburger menu for mobile - Hidden on desktop */}
          <button 
            className="lg:hidden cursor-pointer text-2xl bg-transparent border-none text-gray-800 p-3 flex items-center justify-center z-50"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? '✕' : '☰'}
          </button>

          {/* Desktop Navigation - Hidden on mobile */}
          <nav className="hidden lg:flex flex-1 items-center justify-end ml-10 xl:ml-16">
            <ul className="flex list-none gap-1 xl:gap-3 items-center m-0 p-0">
              <li>
                <Link 
                  to="/" 
                  className="no-underline text-gray-800 font-semibold text-base xl:text-lg hover:text-[#2c5282] transition-colors py-1 px-2"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/about" 
                  className="no-underline text-gray-800 font-semibold text-base xl:text-lg hover:text-[#2c5282] transition-colors py-1 px-2"
                >
                  About
                </Link>
              </li>
              <li>
                <Link 
                  to="/programs" 
                  className="no-underline text-gray-800 font-semibold text-base xl:text-lg hover:text-[#2c5282] transition-colors py-1 px-2"
                >
                  Programs
                </Link>
              </li>
              <li>
                <Link 
                  to="/events" 
                  className="no-underline text-gray-800 font-semibold text-base xl:text-lg hover:text-[#2c5282] transition-colors py-1 px-2"
                >
                  Events
                </Link>
              </li>
              <li>
                <Link 
                  to="/merch" 
                  className="no-underline text-gray-800 font-semibold text-base xl:text-lg hover:text-[#2c5282] transition-colors py-1 px-2"
                >
                  Shop
                </Link>
              </li>
              <li>
                <Link 
                  to="/media" 
                  className="no-underline text-gray-800 font-semibold text-base xl:text-lg hover:text-[#2c5282] transition-colors py-1 px-2"
                >
                  Media
                </Link>
              </li>
            </ul>
          </nav>

          {/* Desktop Join Us button - Hidden on mobile */}
          <div className="hidden lg:flex ml-auto items-center pl-4">
            <Link 
              to="/join" 
              className="bg-[#2c5282] text-white py-2.5 px-6 xl:py-3 xl:px-7 rounded-full font-bold text-sm xl:text-base hover:-translate-y-0.5 hover:shadow-md transition-all no-underline inline-block hover:bg-[#1a365d]"
            >
              Join Us
            </Link>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        <div className={`
          fixed inset-0 bg-white z-40 transition-all duration-300 ease-in-out
          ${isMenuOpen 
            ? 'translate-x-0 opacity-100' 
            : 'translate-x-full opacity-0 pointer-events-none'
          }
          lg:hidden
        `}>
          <div className="pt-24 px-6 h-full overflow-y-auto">
            <nav className="flex flex-col items-center h-full">
              <ul className="flex flex-col list-none w-full p-0 m-0 space-y-1">
                <li className="w-full">
                  <Link 
                    to="/" 
                    className="block no-underline text-gray-800 font-semibold text-xl py-4 px-4 hover:bg-gray-50 hover:text-[#2c5282] rounded-lg transition-colors"
                    onClick={closeMenu}
                  >
                    Home
                  </Link>
                </li>
                <li className="w-full">
                  <Link 
                    to="/about" 
                    className="block no-underline text-gray-800 font-semibold text-xl py-4 px-4 hover:bg-gray-50 hover:text-[#2c5282] rounded-lg transition-colors"
                    onClick={closeMenu}
                  >
                    About
                  </Link>
                </li>
                <li className="w-full">
                  <Link 
                    to="/programs" 
                    className="block no-underline text-gray-800 font-semibold text-xl py-4 px-4 hover:bg-gray-50 hover:text-[#2c5282] rounded-lg transition-colors"
                    onClick={closeMenu}
                  >
                    Programs
                  </Link>
                </li>
                <li className="w-full">
                  <Link 
                    to="/events" 
                    className="block no-underline text-gray-800 font-semibold text-xl py-4 px-4 hover:bg-gray-50 hover:text-[#2c5282] rounded-lg transition-colors"
                    onClick={closeMenu}
                  >
                    Events
                  </Link>
                </li>
                <li className="w-full">
                  <Link 
                    to="/merch" 
                    className="block no-underline text-gray-800 font-semibold text-xl py-4 px-4 hover:bg-gray-50 hover:text-[#2c5282] rounded-lg transition-colors"
                    onClick={closeMenu}
                  >
                    Shop
                  </Link>
                </li>
                <li className="w-full">
                  <Link 
                    to="/media" 
                    className="block no-underline text-gray-800 font-semibold text-xl py-4 px-4 hover:bg-gray-50 hover:text-[#2c5282] rounded-lg transition-colors"
                    onClick={closeMenu}
                  >
                    Media
                  </Link>
                </li>
              </ul>
              
              {/* Mobile Join Us button */}
              <div className="mt-8 w-full px-4">
                <Link 
                  to="/join" 
                  className="block bg-[#2c5282] text-white py-4 px-8 rounded-full font-bold text-lg hover:bg-[#1a365d] transition-colors text-center no-underline w-full"
                  onClick={closeMenu}
                >
                  Join Us
                </Link>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;